import React from 'react'
import { Divider } from '@afterpaytouch/core'
import { SectionHeader } from '../../../../component'
import { DueTodaySection } from './DueTodaySection'
import { PaylaterSection } from './PaylaterSection'
import { useTranslation } from '../../../../utils/convergence'

export const Summary = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <>
      <SectionHeader title={t('summary:summary')} />
      <PaylaterSection />
      <Divider margin='No' />
      <DueTodaySection />
    </>
  )
}
